import * as Yup from 'yup';

export const sendingChatRequestValidation = Yup.object().shape({
	prompt: Yup.string()
		.required('Prompt is required')
		.min(1, 'Prompt must be at least 1 character long')
		.test('prompt', 'Prompt must be at least 1 character long', (value) => value?.trim().length > 0),
});
